import {
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  DialogContentText,
  Button,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Chip,
  fabClasses,
  FormHelperText,
  Backdrop,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  Switch,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import LogoutIcon from "@mui/icons-material/Logout";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Person3Icon from "@mui/icons-material/Person3";
import StyleIcon from "@mui/icons-material/Style";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

export const ProjectsPage = (props) => {
  const [projects, setProjects] = useState([]);
  const [proName, setProName] = useState("");
  const [nameDialog, setNameDialog] = useState(false);

  const [proNameError, setProNameError] = useState(false);
  const [proNameMessage, setProNameMessage] = useState("");

  const [planDialog, setPlanDialog] = useState(false);
  const [adDialog, setAdDialog] = useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [extDb, setExtDb] = useState(false);

  const [dbName, setDbName] = useState("");
  const [dbUser, setDbUser] = useState("");
  const [dbPass, setDbPass] = useState("");
  const [dbHost, setDbHost] = useState("");
  const [dbPort, setDbPort] = useState("");
  const [dbError, setDbError] = useState(false);

  const [database, setDatabase] = useState("2");

  const [plan, setPlan] = useState(false);

  const [planTitle, setPlanTitle] = useState("");
  const [planMessage, setPlanMessage] = useState("");

  const [loader, setLoader] = useState(false);
  const [populated, setPopulated] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  useEffect(() => {
    setLoader(true);
    axios
      .post(
        "https://api.fabloq.com/user/projects/",
        {},
        {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        setProjects(res.data.projects);
        setPlan(res.data.plan);
        if (!sessionStorage.getItem("plan_ad_displayed") && !res.data.plan) {
          sessionStorage.setItem("plan_ad_displayed", true);
          setAdDialog(true);
        }
        setLoader(false);
      });
  }, []);

  const clearDbUser = () => {
    setDbHost("");
    setDbPass("");
    setDbUser("");
    setDbPort("");
  };

  const handleNewProject = () => {
    setProNameError(false);
    if (!Boolean(proName)) {
      setProNameMessage("Please enter a project name.");
      setProNameError(true);

      return;
    }
    setLoader(true);
    let data = new FormData();
    data.append("name", proName);
    data.append("db_type", extDb ? database : "0");
    data.append("db_name", dbName);
    data.append("db_user", dbUser);
    data.append("db_password", dbPass);
    data.append("db_host", dbHost);
    data.append("db_port", dbPort);
    data.append("populated", populated);
    axios
      .post("https://api.fabloq.com/user/project/modify/", data, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      })
      .then((res) => {
        setLoader(false);
        if (res.status === 226) {
          setProNameError(true);
          setProNameMessage(res.data.message);
          return;
        }
        if (res.data.status === "error") {
          if (res.data.type === "project limit reached") {
            setPlanDialog(true);
            setPlanTitle("Plan Limit Reached");
            setPlanMessage(
              "You have reached your project limit under Starter plan. Switch to Pro plan to get unlimited projects."
            );
            return;
          } else if (res.data.type === "connection error") {
            setDbError(true);
            return;
          }
        }
        setNameDialog(false);

        navigate("/workspace/" + res.data.project);
      });
  };

  const handleSelectProject = (e, obj) => {
    e.preventDefault();
    navigate(`/workspace/${obj.id}`);
  };

  const handleRemoveProject = (id) => {
    setLoader(true);
    axios
      .delete("https://api.fabloq.com/user/project/modify/", {
        headers: { Authorization: localStorage.getItem("token") },
        data: {
          project: id,
        },
      })
      .then((res) => {
        axios
          .post(
            "https://api.fabloq.com/user/projects/",
            {},
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            }
          )
          .then((res) => {
            setProjects(res.data.projects);
            setLoader(false);
          });
      });
  };

  return (
    <div className="project-page">
      <Backdrop
        open={loader}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress color="primary" />
      </Backdrop>
      <Dialog
        open={nameDialog}
        className="project-name-dialog"
        onClose={() => {
          setNameDialog(false);
          setExtDb(false);
          clearDbUser();
        }}
      >
        <DialogTitle>Create New Project</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Project Name"
            fullWidth
            variant="standard"
            value={proName}
            error={proNameError}
            helperText={proNameError ? proNameMessage : ""}
            onChange={(e) => {
              setProName(e.target.value);
            }}
          />
        </DialogContent>
        <DialogContent>
          {extDb ? (
            <div className="new-project-db-form">
              <FormControl fullWidth>
                <InputLabel>Select database</InputLabel>
                <Select
                  value={database}
                  label="Select Database"
                  onChange={(e) => {
                    setDatabase(e.target.value);
                  }}
                >
                  <MenuItem value="1">PostgreSQL</MenuItem>
                  <MenuItem value="2">MySQL</MenuItem>
                </Select>
              </FormControl>
              <TextField
                label="Database Name"
                value={dbName}
                onChange={(e) => {
                  setDbName(e.target.value);
                }}
              />
              <TextField
                label="User"
                value={dbUser}
                onChange={(e) => {
                  setDbUser(e.target.value);
                }}
              />
              <TextField
                label="Password"
                value={dbPass}
                onChange={(e) => {
                  setDbPass(e.target.value);
                }}
                type="password"
              />
              <TextField
                label="Host"
                value={dbHost}
                onChange={(e) => {
                  setDbHost(e.target.value);
                }}
              />
              <TextField
                label="Port"
                type="number"
                value={dbPort}
                onChange={(e) => {
                  setDbPort(e.target.value);
                }}
              />
              {database === "2" ? (
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={populated}
                        onChange={() => {
                          setPopulated(!populated);
                        }}
                      />
                    }
                    label="Pre-populated"
                  />
                </FormGroup>
              ) : (
                ""
              )}

              <FormHelperText error={dbError}>
                {dbError
                  ? "Unable to connect to database. Please verify credentials."
                  : ""}
              </FormHelperText>
            </div>
          ) : (
            <Chip
              label="Connect External Database"
              icon={<AddIcon />}
              onClick={() => {
                if (plan) {
                  setExtDb(true);
                } else {
                  setPlanDialog(true);
                  setPlanTitle("Subscribe to Pro Plan");
                  setPlanMessage(
                    "To connect remote database and other advanced features, subscribe to Pro Plan."
                  );
                }
              }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setNameDialog(false);
              setExtDb(false);
              clearDbUser();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              handleNewProject();
            }}
            className="project-submit-button"
          >
            Create
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={planDialog}
        className="project-plan-dialog"
        onClose={() => {
          setPlanDialog(false);
        }}
      >
        <DialogTitle>{planTitle}</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1.5 }} color="#fff">
            {planMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button component={Link} to="profile/plans">
            Explore Plans
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={adDialog}
        onClose={() => {
          setAdDialog(false);
        }}
        className="dashboard-ad-dialog"
      >
        <DialogTitle>Get Pro Plan</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1.5 }} color="#fff">
            Don't limit yourself, create unlimited projects and get many more
            features with a Pro plan at just $12.99/month.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setAdDialog(false);
            }}
            className="ad-dialog-cancel"
          >
            Cancel
          </Button>
          <Button component={Link} to="profile/plans">
            Explore Plans
          </Button>
        </DialogActions>
      </Dialog>
      <div className="project-page-topbar">
        <p className="project-page-title">My Projects</p>
        <a
          href="#"
          className="dashboard-profile-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={(e) => {
            e.preventDefault();

            handleClick(e);
          }}
        >
          <Person3Icon />
          <p>My Profile</p>
        </a>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem component={Link} to="/profile/settings">
            <ListItemIcon>
              <ManageAccountsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Profile Settings</ListItemText>
          </MenuItem>
          <MenuItem component={Link} to="/profile/plans">
            <ListItemIcon>
              <StyleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>My Plan</ListItemText>
          </MenuItem>
          <MenuItem
            onClick={() => {
              props.setLogin(false);
              localStorage.removeItem("token");
            }}
          >
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </MenuItem>
        </Menu>
      </div>
      <div className="project-page-content">
        <a
          href="#"
          className="project-add-card"
          onClick={(e) => {
            e.preventDefault();
            setNameDialog(true);
            setExtDb(false);
            clearDbUser();
            setProNameError(false);
          }}
        >
          <AddIcon color="primary" />
          <p>Create New Project</p>
        </a>
        {projects.map((obj, index) => {
          return (
            <div className="project-card" key={obj.id}>
              <Tooltip title="Delete project">
                <IconButton
                  className="project-card-icon"
                  onClick={() => {
                    handleRemoveProject(obj.id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
              <a href="#" onClick={(e) => handleSelectProject(e, obj)}>
                {obj.name}
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};
